import type { ResultSet } from '@cubejs-client/core'

import { buildCubeQuery } from '@/lib/cube'

/*
 * Sistem Durumu ekranının Cube sorguları (cube/model/kantar/sistem.yml). Saat
 * alanları Cube'ün offset'siz İstanbul duvar saatidir: `formatCubeDateTime` ile gösterilir.
 */

export interface KantarDurum {
  kantarId: string | null
  kantarAdi: string | null
  sonGorulme: string | null
  ajanSurumu: string | null
  kacDakikaOnce: number | null
  baglantiDurumu: string | null
}

export interface SyncDurum {
  kantarId: string | null
  tablo: string | null
  sonSync: string | null
  sonTamYukleme: string | null
  kacSaatOnce: number | null
}

const KANTAR_FIELDS = [
  'kantarId',
  'kantarAdi',
  'sonGorulme',
  'ajanSurumu',
  'kacDakikaOnce',
  'baglantiDurumu',
] as const
const SYNC_FIELDS = ['kantarId', 'tablo', 'sonSync', 'sonTamYukleme', 'kacSaatOnce'] as const

function unqualify<T>(view: string, fields: readonly string[], result: ResultSet): T[] {
  return (result.rawData() as Record<string, unknown>[]).map(
    (row) =>
      Object.fromEntries(fields.map((field) => [field, row[`${view}.${field}`] ?? null])) as T,
  )
}

export const kantarDurumQuery = buildCubeQuery({
  dimensions: KANTAR_FIELDS.map((field) => `KantarDurum.${field}`),
  order: [['KantarDurum.kantarId', 'asc']],
})

export const syncDurumQuery = buildCubeQuery({
  dimensions: SYNC_FIELDS.map((field) => `SyncDurum.${field}`),
  order: [
    ['SyncDurum.kantarId', 'asc'],
    ['SyncDurum.tablo', 'asc'],
  ],
})

export function toKantarDurum(result: ResultSet): KantarDurum[] {
  return unqualify('KantarDurum', KANTAR_FIELDS, result)
}

export function toSyncDurum(result: ResultSet): SyncDurum[] {
  return unqualify('SyncDurum', SYNC_FIELDS, result)
}

/** En yeni `son_sync` — offset'siz ISO dizeleri metin olarak sıralanabilir. */
export function latestSync(rows: SyncDurum[]): string | null {
  return rows.reduce<string | null>(
    (latest, row) => (row.sonSync && (!latest || row.sonSync > latest) ? row.sonSync : latest),
    null,
  )
}
